export default __webpack_public_path__ + "static/media/currency.842e3001.svg";